import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/shared.module';
import { StrongPasswordRegx } from '../../../../../shared/utils/data/shared.data';
import { civilityOptions } from '../../../../../shared/utils/data/etablissments-data';
import { AuthService } from '../../../../../services/auth.service';
import { FlagService } from '../../../../../shared/services/flag.service';
import { FlagType } from '../../../../../shared/utils/enums';

@Component({
  selector: 'app-first-step-add-establishment',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule
  ],
  templateUrl: './first-step-add-establishment.component.html',
  styleUrls: ['./first-step-add-establishment.component.scss']
})
export class FirstStepAddEstablishmentComponent {
  @Input() form!: FormGroup;
  @Input() loading = false;
  @Output() onValidated = new EventEmitter<any>();

  civilityOptions = civilityOptions;
  get passwordFormField() {
    return this.form.get('password')?.value;
  }

  constructor(public authService: AuthService, private flag: FlagService) {}

  nextStep(): void {
    if (this.form.valid) {
      this.loading = true;
      const body = {
        email: this.form.get('email')?.value,
        password: "Ee123456@",
        kind: 'ETABLISSEMENT',
        source: 'AGENCY_ETB'
      };
      this.authService.signupAgency(body).subscribe({
        next: (res: any) => {
          if (res.status === 'success' && res.data?.collary_id) {
            localStorage.setItem('temp_id', res.data.collary_id);
            localStorage.setItem('temp_user', JSON.stringify(res.data));
            this.onValidated.emit(this.form.value);
          } else {
            this.loading = false;
          }
        },
        error: (e: any) => {
          this.loading = false;
          // Privilege the backend message (e.g. "Email is already in use!"), then fall back.
          const backendMsg = (e?.error?.message || '').replace(/^Error:\s*/i, '').trim();
          this.flag.displayFlag(backendMsg || 'Une erreur est survenue lors de la création du compte.', FlagType.error);
        },
        complete: () => this.loading = false
      });
    }
  }

  get isFormDisabled(): boolean {
    return this.form.invalid || this.loading;
  }
}
